module.exports = __webpack_public_path__ + "static/media/thumbnail.28c7aff6.jpg";